var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-content"},[_vm._t("icon"),_c('h3',{staticClass:"fancy-heading"},[_c('span',[_vm._t("title")],2)]),_c('div',{staticClass:"text-content"},[_vm._t("body")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }